(() => {
  if (customElements.get('pax-collection-pager')) return;
  class PaxCollectionPager extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.ready) return;
        this.ready = true;
        const url = new URL(location.href);
        if (this.dataset.legacyPage) {
          url.searchParams.set('pax_page', this.dataset.legacyPage);
          url.searchParams.delete('page');
          location.replace(url.href);
          return;
        }
        this.grid = this.querySelector('#product-grid');
        this.cache = new Map([[1, [...this.grid.children]]]);
        this.size = Math.max(1, Number(this.dataset.pageSize) || 24);
        this.pages = Math.ceil(Number(this.dataset.total) / this.size);
        this.nav = this.querySelector('[data-pax-pagination]');
        this.status = this.querySelector('[data-pax-page-status]');
        if (!this.nav || this.pages < 2) return;
        const fallback = this.querySelector('[data-pax-fallback]');
        if (fallback) fallback.hidden = true;
        this.nav.hidden = false;
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-pax-page-step]');
          if (!button || !this.contains(button)) return;
          this.show(this.page + Number(button.dataset.paxPageStep), true);
        });
        this.onHistory = () => this.show(Number(new URL(location.href).searchParams.get('pax_page')) || 1, false);
        window.addEventListener('popstate', this.onHistory);
        this.onHistory();
      });
    }
    disconnectedCallback() {
      window.removeEventListener('popstate', this.onHistory);
    }
    show(requested, moveFocus) {
      this.page = Math.min(this.pages, Math.max(1, Math.floor(requested) || 1));
      if (!this.cache.has(this.page)) {
        const source = this.querySelector(`noscript[data-pax-page="${this.page}"]`);
        const content = document.createElement('template');
        content.innerHTML = source.textContent;
        this.cache.set(this.page, [...content.content.querySelectorAll('ul > li')]);
      }
      this.grid.replaceChildren(...this.cache.get(this.page));
      this.querySelector('[data-pax-page-step="-1"]').disabled = this.page === 1;
      this.querySelector('[data-pax-page-step="1"]').disabled = this.page === this.pages;
      this.status.textContent = this.dataset.pageLabel.replace('[current]', this.page).replace('[total]', this.pages);
      if (moveFocus) {
        const url = new URL(location.href);
        if (this.page === 1) url.searchParams.delete('pax_page');
        else url.searchParams.set('pax_page', this.page);
        history.replaceState({...history.state, searchParams: url.search.slice(1)}, '', url);
        this.grid.focus({preventScroll: true});
        this.grid.scrollIntoView({block: 'start', behavior: 'instant'});
      }
    }
  }
  customElements.define('pax-collection-pager', PaxCollectionPager);
})();
